<pre v-html="syntaxHighlight(this.data)" style="resize:both;overflow:auto;max-width:100%;"></pre>